import { Link } from "react-router-dom";
import logo from "../images/techvanto-logo.png";
import { FOOTER_LINKS } from "../data/navLinks";

const LOGO_SRC = logo;

export default function Footer() {
  const cols = [
    { title: "Services", links: FOOTER_LINKS.Services },
    { title: "Company", links: FOOTER_LINKS.Company },
    { title: "Solutions", links: FOOTER_LINKS.Solutions },
  ];

  return (
    <footer style={{ background: "#0F172A", color: "#fff", padding: "72px 40px 32px" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div className="footer-grid" style={{ marginBottom: 56 }}>
          <div>
            <div style={{ marginBottom: 16 }}>
              <Link to="/">
                <img
                  src={LOGO_SRC}
                  alt="Techvanto"
                  style={{ height: 150, width: "auto", objectFit: "contain", filter: "brightness(0) invert(1)", display: "block" }}
                />
              </Link>
            </div>
            <p style={{ color: "#94A3B8", lineHeight: 1.75, fontSize: 14, maxWidth: 300, marginBottom: 24 }}>
              Building world-class digital products for businesses across 20+ countries. Innovation. Scale. Excellence.
            </p>
          </div>
          {cols.map((col) => (
            <div key={col.title}>
              <h4 style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 14, color: "#fff", marginBottom: 20, letterSpacing: ".04em" }}>{col.title}</h4>
              {col.links.map((l) => (
                <Link
                  key={l.label}
                  to={l.path}
                  style={{ display: "block", color: "#64748B", fontSize: 13.5, textDecoration: "none", marginBottom: 10, transition: "color .15s" }}
                  onMouseEnter={(e) => { e.target.style.color = "#93C5FD"; }}
                  onMouseLeave={(e) => { e.target.style.color = "#64748B"; }}
                >
                  {l.label}
                </Link>
              ))}
            </div>
          ))}
        </div>
        <div className="footer-bottom" style={{ borderTop: "1px solid #1E293B", paddingTop: 28, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <p style={{ color: "#475569", fontSize: 13 }}>© 2025 Techvanto Private Limited. All rights reserved.</p>
          <p style={{ color: "#475569", fontSize: 13 }}>Made with ❤️ in India 🇮🇳</p>
        </div>
      </div>
    </footer>
  );
}
